import { useEffect, useState } from 'react';
import {
  PREVIEW_STATE,
  PREVIEW_STATE_DELIMETER,
} from '../editor/megaMenuConfig/constants';
import type {
  IMenuPreviewWrapperProps,
  MenuItemData,
} from '../../components/Menu/Menu.types';
import { getDropdownToPreview } from '../../components/Menu/viewer/utils/dropdownPreview';

export const useEditSlotId = (compPreviewState?: string | null): string => {
  const [slotId, setSlotId] = useState('');

  useEffect(() => {
    if (compPreviewState?.startsWith(PREVIEW_STATE.FREEZE_MEGA_MENU)) {
      setSlotId(compPreviewState.split(PREVIEW_STATE_DELIMETER).pop()!);
    }
    if (compPreviewState === PREVIEW_STATE.UNFREEZE_MEGA_MENU) {
      setSlotId('');
    }
  }, [compPreviewState]);

  return slotId;
};

type UseDropdownPreviewProps = IMenuPreviewWrapperProps & {
  slots?: Record<string, JSX.Element>;
  items: Array<MenuItemData>;
};

export type UseDropdownPreview = {
  shownDropdownId?: string;
  editSlotId?: string;
  itemId?: string;
};

export const useDropdownPreview = ({
  slots,
  compPreviewState,
  layoutPanelPreviewStateMap,
  designPanelPreviewStateMap,
  items,
}: UseDropdownPreviewProps): UseDropdownPreview => {
  const slotId = useEditSlotId(compPreviewState);
  if (slotId) {
    return { shownDropdownId: slots?.[slotId]?.props.id, editSlotId: slotId };
  }
  if (
    layoutPanelPreviewStateMap ||
    designPanelPreviewStateMap?.selectedPartId?.startsWith('dropdown')
  ) {
    const dropdownToPreview = getDropdownToPreview({ items, slots });
    const editSlotId = dropdownToPreview?.slot;

    return editSlotId
      ? { shownDropdownId: slots?.[editSlotId]?.props.id, editSlotId }
      : {
          shownDropdownId: dropdownToPreview
            ? `${dropdownToPreview.id}-dropdown`
            : undefined,
          itemId: dropdownToPreview?.id,
        };
  }
  return {};
};
